import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { ConfirmDialogHost } from "./components/ConfirmDialog";
import ProtectedRoute, { HomeRedirect } from "./components/Protectedroute";
import SignIn from "./pages/SignIn";
import Dashboard from "./pages/Dashboard";
import TenantManagement from "./pages/TenantManagement";
import TenantDetails from "./pages/TenantDetails";
import EstateAccess from "./pages/EstateAccess";
import RentManagement from "./pages/RentManagement";
import UserManagement from "./pages/UserManagement";
import ScholarshipManagement from "./pages/ScholarshipManagement";
import ScholarshipDetails from "./pages/ScholarshipDetails";
import CarManagement from "./pages/CarManagement";
import EstateSetup from "./pages/EstateSetup";
import SecurityIncidents from "./pages/SecurityIncidents";
import NfcCards from "./pages/NfcCards";
import Reports from "./pages/Reports";
import TenantRequests from "./pages/TenantRequests";
import OccupantDetail from "./pages/OccupantDetail";
import Profile from "./pages/Profile";
import RentDetails from "./pages/RentDetails";
import SeePayment from "./pages/SeePayment";
import AuditLog from "./pages/AuditLog";

// ── Tenant Portal (copied from Matilda) ─────────────────────
import TenantLayout, { TenantProtectedRoute } from "./tenant/pages/TenantLayout";
import TenantDashboard from "./tenant/pages/TenantDashboard";
import TenantBuildings from "./tenant/pages/TenantBuildings";
import TenantDependants from "./tenant/pages/TenantDependants";
import TenantCars from "./tenant/pages/TenantCars";
import TenantMaintenance from "./tenant/pages/TenantMaintenance";
import TenantVisits from "./tenant/pages/TenantVisits";
import TenantPayments from "./tenant/pages/TenantPayments";
import TenantProfile from "./tenant/pages/TenantProfile";


export default function App() {
  useEffect(() => {
    const html = document.documentElement;
    const saved = localStorage.getItem("kt_theme_mode") || localStorage.getItem("data-bs-theme") || "light";
    html.setAttribute("data-bs-theme", saved);
    localStorage.setItem("kt_theme_mode", saved);
    localStorage.setItem("data-bs-theme", saved);

    const handleChange = () => {
      const mode = html.getAttribute("data-bs-theme");
      if (mode) {
        localStorage.setItem("kt_theme_mode", mode);
      }
    };

    html.addEventListener("kt.thememode.change", handleChange);

    const onClick = (e) => {
      const el = e.target.closest('[data-kt-element="mode"]');
      if (!el) return;
      const mode = el.getAttribute("data-kt-value");
      if (mode) {
        localStorage.setItem("kt_theme_mode", mode);
        localStorage.setItem("data-bs-theme", mode);
        if (window.KTThemeMode?.setMode) {
          window.KTThemeMode.setMode(mode);
        } else {
          html.setAttribute("data-bs-theme", mode);
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      html.removeEventListener("kt.thememode.change", handleChange);
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <>
      <Routes>
        {/* Public */}
        <Route path="/sign-in" element={<SignIn />} />

        {/* Protected */}
        <Route path="/dashboard"            element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/tenants"              element={<ProtectedRoute><TenantManagement /></ProtectedRoute>} />
        <Route path="/tenants/:id"          element={<ProtectedRoute><TenantDetails /></ProtectedRoute>} />
        <Route path="/estate-access"        element={<ProtectedRoute><EstateAccess /></ProtectedRoute>} />
        <Route path="/rent-management"      element={<ProtectedRoute><RentManagement /></ProtectedRoute>} />
        <Route path="/rent-details/:tenantId" element={<ProtectedRoute><RentDetails /></ProtectedRoute>} />
        <Route path="/payments"             element={<ProtectedRoute><SeePayment /></ProtectedRoute>} />
        <Route path="/see-payments"         element={<ProtectedRoute><SeePayment /></ProtectedRoute>} />
        <Route path="/seepayment"           element={<ProtectedRoute><SeePayment /></ProtectedRoute>} />
        <Route path="/user-management"      element={<ProtectedRoute estateOnly><UserManagement /></ProtectedRoute>} />
        <Route path="/audit-log"            element={<ProtectedRoute estateOnly><AuditLog /></ProtectedRoute>} />
        <Route path="/scholarship"          element={<ProtectedRoute><ScholarshipManagement /></ProtectedRoute>} />
        <Route path="/scholarship/:id"      element={<ProtectedRoute><ScholarshipDetails /></ProtectedRoute>} />
        <Route path="/car-management"       element={<ProtectedRoute><CarManagement /></ProtectedRoute>} />
        <Route path="/tenants/:tenantId/occupants/:occupantId" element={<ProtectedRoute><OccupantDetail /></ProtectedRoute>} />
        
        <Route path="/estate-setup"         element={<ProtectedRoute estateOnly><EstateSetup /></ProtectedRoute>} />
        <Route path="/security-incidents"   element={<ProtectedRoute><SecurityIncidents /></ProtectedRoute>} />
        <Route path="/nfc-cards"            element={<ProtectedRoute><NfcCards /></ProtectedRoute>} />
        <Route path="/reports"              element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/profile"              element={<ProtectedRoute><Profile /></ProtectedRoute>} />

        <Route path="/tenant-requests"      element={<ProtectedRoute><TenantRequests /></ProtectedRoute>} />

        {/* Tenant Portal */}
        <Route path="/tenant/sign-in" element={<Navigate to="/sign-in?role=tenant" replace />} />
        <Route
          path="/tenant"
          element={
            <TenantProtectedRoute>
              <TenantLayout />
            </TenantProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/tenant/dashboard" replace />} />
          <Route path="dashboard"    element={<TenantDashboard />} />
          <Route path="buildings"    element={<TenantBuildings />} />
          <Route path="dependants"   element={<TenantDependants />} />
          <Route path="cars"         element={<TenantCars />} />
          <Route path="access-codes" element={<Navigate to="/tenant/dependants" replace />} />
          <Route path="maintenance"  element={<TenantMaintenance />} />
          <Route path="visits"       element={<TenantVisits />} />
          <Route path="payments"     element={<TenantPayments />} />
          <Route path="profile"      element={<TenantProfile />} />
        </Route>

       

        {/* Fallbacks */}
        <Route path="/"  element={<HomeRedirect />} />
        <Route path="*"  element={<HomeRedirect />} />
      </Routes>

      <ConfirmDialogHost />

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { borderRadius: "12px", background: "#1f2937", color: "#fff" },
          success: { style: { background: "#0EA84A" } },
          error:   { style: { background: "#DC2626" } },
        }}
      />
    </>
  );
}